import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField
} from 'react-admin';

// own ui
import CustomFilterTextCategoryServiceActive from '../../ui/custom-filter-text-category-service-active';
import SubCategoryServiceExporter from '../../exporter/sub-category-service-exporter';

const SubCategoryServiceList = (props) => (
    <List
      title="Sub Categorias de Serviço" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterTextCategoryServiceActive /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ SubCategoryServiceExporter } >
        <Datagrid>
          <TextField source="id" sortable={true} />
          <TextField source="category_service_name" label="Categoria de Serviço" sortable={false} />
          <TextField source="name.pt_br" label="Nome" sortable={false} />
          <BooleanField source="active" label="Ativo" sortable={false} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
          <EditButton />
        </Datagrid>
    </List>
);

export default SubCategoryServiceList;
